import { Box, CircularProgress as MUICircularProgress, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { ProgressContainer } from "./CircularProgress.styles";
import { CircularProgressProps } from "./CircularProgress.types";

export function CircularProgress({ percentageOfCompletion, thickness = 4, circleColor = "secondary" }: CircularProgressProps) {

  const theme = useTheme();
  const value = (percentageOfCompletion ? parseInt(percentageOfCompletion.replaceAll("%", "")) : 0);

  return (
    <Box position="relative" display="inline-flex">
      <MUICircularProgress
        variant="determinate"
        value={ 100 }
        thickness={ thickness }
        size={ 40 }
        sx={ {
          color: "#e0e0e0"
        } }
      />
      <ProgressContainer>
        <MUICircularProgress
          variant="determinate"
          value={ value }
          thickness={ thickness }
          size={ 40 }
          sx={ {
            color: circleColor
          } }
        />
      </ProgressContainer>

      <ProgressContainer>
        <Typography
          variant="caption"
          component="div"
          sx={ {
            fontSize: "10px",
            fontWeight: 500,
            color: theme.customColors.exploreCardText,
            textShadow: `0px 0px 2px rgba(${theme.customColors.gradient08End})`,
            lineHeight: 1
          } }
        >{ percentageOfCompletion }</Typography>
      </ProgressContainer>
    </Box>
  );
}
